export const equipmentCalibrationGridDepreciationReport = {
    bindings: {},
    /* @ngInject */
    controller: function ($ngRedux, EquipmentCalibrationActions, DocumentManager, Notifier) {
        /**
         * @function $onInit
         */
        this.$onInit = () => {
            this.unsubscribe = $ngRedux.connect(({ equipmentCalibration }) => ({
                ety_id: equipmentCalibration.equipment.type,
            }), EquipmentCalibrationActions)(this);
        }

        this.onExport = () => {
            if (this.equGridCustomForm.$valid) {
                Notifier.info('Please wait...', false);
                this.getDepreciationReport(this.ety_id)
                    .then((data) => {
                        DocumentManager.downloadFile('/' + data.path);
                        Notifier.success('Export Complete!');
                    })
                    .catch(() => Notifier.error('System Error!'));
            } else {
                Notifier.error('Please select equipment type');
            }
        };

        this.$onDestroy = () => {
            this.unsubscribe();
        }
    },
    template: `
        <form id="equGridCustomForm"
              name="$ctrl.equGridCustomForm"
              layout-gt-xs="row"
              layout-align-xs="center center"
              layout-align-sm="center center"
              novalidate>
            <div flex hide-xs hide-sm></div>
            <div layout="row" flex-xs="100" layout-align-xs="center center">
                <div layout="row" style="width: 206px">
                    <input-select flex label="Depreciation Report"
                                  identifier="equipment"
                                  state-path="type"
                                  state-data="types"
                                  state-data-module="equipmentCalibration"
                                  state-data-identifier="equipment"
                                  required="true">
                    </input-select>
                </div>
            </div>
            <div layout="row"
                 layout-align-xs="center center"
                 layout-align-sm="center center">
                <md-button type="submit" class="btnDefault" ng-click="$ctrl.onExport()">
                    <asset src="export-gray.svg"></asset> Export
                </md-button>
            </div>
        </form>
    `,
};
